import { render, staticRenderFns } from "./RequestWrapper.vue?vue&type=template&id=5df2d4d2&"
import script from "./RequestWrapper.vue?vue&type=script&lang=js&"
export * from "./RequestWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports